"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateManualBackupDialog = void 0;
const react_1 = __importStar(require("react"));
const components_1 = require("@veeam/components");
const core_1 = require("@veeam/core");
const core_2 = require("../../../core");
const CreateManualBackupInteractor_1 = require("./CreateManualBackupInteractor");
const CreateManualBackupModel_1 = require("./CreateManualBackupModel");
require("./types");
const CreateManualBackupDialog = ({ initialRepository, repositoriesLoadableModel, createManualBackupLoadableModel, onDeactivate, onDone, onCancel, onClose, onCatchError, texts, }) => {
    const { platformName } = core_2.useProductContext();
    const { t } = core_2.useFeatureContext();
    const [isRepositoriesLoading, repositoryListLoadingState] = react_1.useState(false);
    const [isCreateLoading, createLoadingState] = react_1.useState(false);
    const { interactor } = core_1.useInteractor(() => {
        const model = new CreateManualBackupModel_1.CreateManualBackupDialogModel({
            repositoryId: initialRepository === null || initialRepository === void 0 ? void 0 : initialRepository.id,
            repositoryName: initialRepository === null || initialRepository === void 0 ? void 0 : initialRepository.name,
        });
        const listeners = {
            onDeactivate,
            onDone,
            onCancel,
            onClose,
        };
        const presenters = {
            repositoryListLoadingState,
            createLoadingState,
            onCatchError,
        };
        const loaders = {
            repositoriesLoader: repositoriesLoadableModel,
            onCreateLoader: createManualBackupLoadableModel,
        };
        return new CreateManualBackupInteractor_1.CreateManualBackupInteractor(model, loaders, listeners, presenters);
    });
    return (react_1.default.createElement(components_1.Dialog, { id: "createManualBackupDialog", header: (texts === null || texts === void 0 ? void 0 : texts.header) || t('createManualBackupDialog|header'), size: {
            width: components_1.DIALOG_SIZE.xs,
            height: components_1.DIALOG_SIZE.auto,
        }, onRequestClose: () => {
            interactor.onClose();
        }, loading: isRepositoriesLoading || isCreateLoading, actions: [
            {
                view: components_1.ACTION_VIEW.primary,
                text: (texts === null || texts === void 0 ? void 0 : texts.buttonDone) || t('createManualBackupDialog|actions|done|label'),
                onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                    yield interactor.onDone();
                }),
            },
            {
                view: components_1.ACTION_VIEW.secondary,
                text: (texts === null || texts === void 0 ? void 0 : texts.buttonCancel) || t('createManualBackupDialog|actions|cancel|label'),
                onClick: () => {
                    interactor.onCancel();
                },
            },
        ] },
        react_1.default.createElement(components_1.FormLayout, null,
            react_1.default.createElement(components_1.ComboboxField, { label: (texts === null || texts === void 0 ? void 0 : texts.repositoryLabel) || t('createManualBackupDialog|form|fields|repository|label'), field: interactor.form.fields.repositoryId, model: repositoriesLoadableModel, placeholder: (texts === null || texts === void 0 ? void 0 : texts.repositoryPlaceholder) ||
                    t('createManualBackupDialog|form|fields|repository|placeholder'), controlRenderer: components_1.createSearchableControl(), size: components_1.CONTROL_SIZE.full }),
            react_1.default.createElement(components_1.NoLabelGroup, { control: react_1.default.createElement(components_1.HelpText, null, (texts === null || texts === void 0 ? void 0 : texts.repositoryHelperText) ||
                    t('createManualBackupDialog|form|fields|repository|helperText')) }),
            react_1.default.createElement(components_1.CheckboxField, { label: (texts === null || texts === void 0 ? void 0 : texts.isIncludeHistoryLabel) ||
                    t('createManualBackupDialog|form|fields|isIncludeHistory|label'), field: interactor.form.fields.isIncludeSessionHistory, helpText: (texts === null || texts === void 0 ? void 0 : texts.isIncludeHistoryHelperText) ||
                    t('createManualBackupDialog|form|fields|isIncludeHistory|helperText', {
                        platform: platformName,
                    }), helpTextView: components_1.FIELD_LAYOUT_HELP_TEXT_VIEW.labelDescription }))));
};
exports.CreateManualBackupDialog = CreateManualBackupDialog;
//# sourceMappingURL=CreateManualBackupDialog.js.map